var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24634 19.3358V35.9986H17.3215H26.6217H36.6969V19.3358L21.9716 5.9668L7.24634 19.3358ZM19.8403 33.4798V24.3734H24.1029V33.4798H19.8403ZM34.1781 33.4798H26.6217V21.8546H17.3215V33.4798H9.76513V20.4596L21.9716 9.37686L34.1781 20.4596V33.4798Z",
    fill: "#08A2AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9717 0L0 19.9372L1.68566 21.8167L21.9717 3.41006L42.2383 21.8167L43.9239 19.9372L21.9717 0Z",
    fill: "#08A2AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHome);
export default __webpack_public_path__ + "static/media/ico-home.5865373fad09e5d731d10ec2d7af1f64.svg";
export { ForwardRef as ReactComponent };